import { render, staticRenderFns } from "./viewTaskDrawer.vue?vue&type=template&id=b06d269e&scoped=true&"
import script from "./viewTaskDrawer.vue?vue&type=script&lang=js&"
export * from "./viewTaskDrawer.vue?vue&type=script&lang=js&"
import style0 from "./viewTaskDrawer.vue?vue&type=style&index=0&id=b06d269e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06d269e",
  null
  
)

export default component.exports